export default __webpack_public_path__ + "static/media/aiops_1.1ae8ae18.png";